import {Component} from '@lib/Component';

export class Hover extends Component {
  constructor() {
    super();
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  didMount() {
    this.element?.addEventListener('mouseenter', this.onMouseEnter);
    this.element?.addEventListener('mouseleave', this.onMouseLeave);
  }

  didUnmount() {
    this.element?.removeEventListener('mouseenter', this.onMouseEnter);
    this.element?.removeEventListener('mouseleave', this.onMouseLeave);
  }

  onMouseEnter() {
    this.element?.classList.add('hover');
  }

  onMouseLeave() {
    this.element?.classList.remove('hover');
  }
}
